import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";
import Dashboard from "../pages/Dashboard.vue";
import Home from "@/pages/Home.vue";
import Login from "@/pages/Login.vue";
import Users from "@/pages/Users.vue";
import UserDetail from "@/pages/UserDetail.vue";
import CreditApplications from "@/pages/CreditApplications.vue";
import CreditApplicationDetail from "@/pages/CreditApplicationDetail.vue";
import PendingVerification from "@/pages/PendingVerification";
import PendingDetail from "@/pages/PendingDetail";
import Waitlist from "@/pages/Waitlist";
import Credit from "@/pages/Credit";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "/users",
        name: "users",
        component: Users
      },
      {
        path: "/users/:id",
        name: "user-detail",
        component: UserDetail
      },
      {
        path: "/credit",
        name: "credit-applications",
        component: CreditApplications
      },
      {
        path: "/credit/:id",
        name: "credit-application-detail",
        component: CreditApplicationDetail
      },
      {
        path: "/pending",
        name: "pending-verification",
        component: PendingVerification
      },
      {
        path: "/pending/:id",
        name: "pending-detail",
        component: PendingDetail
      },
      {
        path: "/waitlist",
        name: "waitlist",
        component: Waitlist
      },
      {
        path: "/credit-history",
        name: "credit",
        component: Credit
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, _, next) => {
  let openViews = ["login"];
  let canAccess = openViews.includes(to.name) || store.getters.isLoggedIn;
  return canAccess ? next() : next("/login");
});

export default router;
